import { render, staticRenderFns } from "./DeliveriesTableMobile.vue?vue&type=template&id=ac7a06c6&lang=pug&"
import script from "./DeliveriesTableMobile.vue?vue&type=script&lang=js&"
export * from "./DeliveriesTableMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports